import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Input, Row, Col, Spin, Tooltip } from 'antd';
import { captchaConfig } from '../../utils/constants';
import Captcha from '../../components/Captcha.tsx';
import s from './style.m.less';
import { rules, regular } from 'grt-tool-lib-front';
import { LoadingOutlined, QuestionCircleOutlined } from '@ant-design/icons';
const { registerRule, checkIsMobile, checkRequired, checkPassword } = rules;

@inject('store')
@observer
class Password extends Component {
    constructor(props) {
        super(props);
        this.myForm = React.createRef();
        this.state = {
            captcha: {
                remoteUrl: captchaConfig.host,
                captchaId: captchaConfig.captchaId,
                onSuccess: this.captchaSuccess.bind(this)
            },
            smsCanClick: false,
            codeMessage: '获取验证码',
            yuyinShow: false,
            loading: false,
            type: props.type || ''
        };
    }

    /**
     * 行为验证码验证成功回调
     * @param result
     */
    async captchaSuccess(result) {
        const {
            store: { login }
        } = this.props;

        login.setCaptchaVisible(false);
        const mobile = this.myForm.current.getFieldValue('mobile'),
            succcess = await login.getSmn({
                mobile,
                captcha_token: result.token,
                biz_type: 2, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请
                types: 1 //1短信2语音
            });

        if (succcess) {
            this.countDown(60);
        }
    }

    onFinishFirst = (values) => {
        const {
            store: { login }
        } = this.props;

        login.verifyFirst(values);
    };

    onFinishSecond = (values) => {
        const {
            store: { login }
        } = this.props;

        login.verifySecond(Object.assign(values, { verify_token: login.verify_token }));
    };

    yuyinSms = () => {
        const {
            store: { login }
        } = this.props;

        this.myForm.current.validateFields(['mobile']).then((values) => {
            login.getSmn({
                mobile: values.mobile,
                biz_type: 2, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请
                types: 2 //1短信2语音
            });
        });
    };

    sendSmn = async () => {
        const {
            store: { login }
        } = this.props;

        if (this.state.smsCanClick) {
            this.setState({ loading: true }, () => {
                this.myForm.current.validateFields(['mobile']).then(async (values) => {
                    const succcess = await login.getSmn({
                        mobile: values.mobile,
                        biz_type: 2, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请
                        types: 1 //1短信2语音
                    });

                    if (succcess) {
                        this.countDown(60);
                    }
                });
            });
        }
    };

    toggleLogin = () => {
        const {
            store: { login }
        } = this.props;

        login.setMode('login');
        login.setForgetStep(1);
    };

    onValuesChange = () => {
        this.myForm.current
            .validateFields(['mobile'])
            .then(() => {
                this.setState({ smsCanClick: true });
            })
            .catch(({ errorFields }) => {
                if (errorFields.length) {
                    this.setState({ smsCanClick: false });
                }
            });
    };

    /**
     * 验证码读秒
     * @param time
     */
    countDown(time = 60) {
        const timeout = setTimeout(() => {
            if (time === 1) {
                clearTimeout(timeout);
                this.onValuesChange();
                this.setState({
                    codeMessage: '重新获取'
                });
            } else {
                time--;
                this.setState({
                    codeMessage: `${time} s`,
                    // yuyinShow: time < 45,
                    smsCanClick: false,
                    loading: false
                });
                this.countDown(time);
            }
        }, 1000);
    }

    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <>
                <Captcha {...this.state.captcha} show={login.captchaVisible} />

                <a style={{ fontSize: '12px' }} onClick={this.toggleLogin}>
                    <span className={s.back}></span>返回登录
                </a>
                <h3 style={{ margin: '20px 0', fontSize: '24px' }}>忘记密码</h3>
                {login.forgetStep === 1 ? (
                    <>
                        <p>第一步：手机验证</p>
                        <Form
                            ref={this.myForm}
                            name="first"
                            onValuesChange={this.onValuesChange}
                            validateTrigger="onBlur"
                            onFinish={this.onFinishFirst}
                        >
                            <Form.Item name="mobile" rules={[checkRequired('请填写手机号'), registerRule(checkIsMobile, '手机号格式错误')]}>
                                <Input placeholder="请输入手机号" />
                            </Form.Item>

                            <Form.Item
                                name="captcha"
                                validateTrigger="onChange"
                                rules={[
                                    checkRequired('请输入验证码'),
                                    () => ({
                                        validator: (_, value) => {
                                            if (!value) {
                                                return Promise.resolve();
                                            }
                                            if (value.length !== 6) {
                                                return Promise.reject('验证码格式错误');
                                            }
                                            if (!regular.isNum.test(value)) {
                                                return Promise.reject('验证码格式错误');
                                            }
                                            return Promise.resolve();
                                        }
                                    })
                                ]}
                                extra={
                                    this.state.yuyinShow ? (
                                        <div
                                            style={{
                                                textAlign: 'right',
                                                lineHeight: '24px',
                                                fontSize: '12px'
                                            }}
                                        >
                                            收不到验证码？
                                            <a onClick={this.yuyinSms}>尝试语音验证码</a>
                                        </div>
                                    ) : null
                                }
                            >
                                <Input
                                    placeholder="验证码"
                                    suffix={
                                        <Spin spinning={this.state.loading} indicator={<LoadingOutlined spin />} size="small">
                                            <span onClick={this.sendSmn} className={!this.state.smsCanClick ? s.disabled : s.abled}>
                                                {this.state.codeMessage}
                                            </span>
                                        </Spin>
                                    }
                                />
                            </Form.Item>
                            {this.state.type === 'competition' ? null : <a> &nbsp;</a>}
                            <Form.Item>
                                <Row gutter={12} style={{ marginTop: this.state.type === 'competition' ? '0' : '56px' }}>
                                    <Col span={12}>
                                        <Button block type="primary" htmlType="submit">
                                            下一步
                                        </Button>
                                    </Col>
                                    <Col span={12}>
                                        <Button block onClick={this.toggleLogin}>
                                            取消
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </Form>
                    </>
                ) : (
                    <>
                        <p>
                            <span style={{ marginRight: '4px' }}>第二步：设置新密码</span>
                            <Tooltip title="密码为8-16位，需要至少包含：大写字母、小写字母、数字、特殊符号中的四类，且不能为生日或简单键盘组合">
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </p>
                        <Form name="second" onFinish={this.onFinishSecond}>
                            <Form.Item
                                name="pwd"
                                rules={[
                                    {
                                        required: true,
                                        message: '请输入密码'
                                    },
                                    registerRule(checkPassword)
                                ]}
                            >
                                <Input.Password placeholder="请设置8位以上新密码" />
                            </Form.Item>

                            <Form.Item
                                name="confirm_pwd"
                                rules={[
                                    {
                                        required: true,
                                        message: '请再次输入密码'
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('pwd') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('两次输入的密码不一致');
                                        }
                                    })
                                ]}
                            >
                                <Input.Password placeholder="请再次输入新密码" />
                            </Form.Item>
                            {this.state.type === 'competition' ? null : <a> &nbsp;</a>}

                            <Form.Item>
                                <Row gutter={12} style={{ marginTop: this.state.type === 'competition' ? '0' : '64px' }}>
                                    <Col span={12}>
                                        <Button block type="primary" htmlType="submit">
                                            确定
                                        </Button>
                                    </Col>
                                    <Col span={12}>
                                        <Button block onClick={this.toggleLogin}>
                                            取消
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </Form>
                    </>
                )}
            </>
        );
    }
}

export default Password;
